import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { OktaAuth } from '@okta/okta-auth-js';
import { provideOktaAuth, withOktaConfig } from '@okta/okta-angular';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { authInterceptor } from './core/auth.interceptor';
import { ASSISTANT_CONTEXT_PROVIDER } from './support/assistant/assistant-context';

// Exported so a test can guard the security-relevant settings (notably autoRenew) without reaching into
// OktaAuth internals.
export const oktaAuthConfig = {
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: environment.okta.redirectUri,
  postLogoutRedirectUri: environment.okta.postLogoutRedirectUri,
  scopes: environment.okta.scopes,
  pkce: true,
  tokenManager: {
    // No silent background renewal. The 30-minute access token is allowed to lapse; SessionTimeoutService
    // warns before expiry and then signs out, and the user renews only by explicitly choosing "Stay signed
    // in". Prevent Okta removing the token before the warning/logout handler runs.
    autoRenew: false,
    // Let the app show its warning and complete Okta end-session before token removal.
    autoRemove: false,
    // Persist managed Okta tokens in localStorage (one configured token store).
    storage: 'localStorage' as const,
  },
};

const oktaAuth = new OktaAuth(oktaAuthConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    ASSISTANT_CONTEXT_PROVIDER,
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideOktaAuth(withOktaConfig({ oktaAuth })),
  ],
};
